import { Layout } from 'antd';
import styled from 'styled-components';

export const StyledLayout = styled(Layout)`
  overflow: hidden;
  background: #fff;
  min-height: 100vh;
`;
